import {useContext} from "react";

import {
    GuideAudioContext,
    type GuideAudioController,
} from "../internal/guide-audio-context.ts";

/**
 * Provide access to the guide audio controller.
 */
export const useGuideAudioController = (): GuideAudioController =>
    useContext(GuideAudioContext);
